export default __webpack_public_path__ + "static/cndf-community-a4c6f1a3d8e402d271ed02fe6acfefec.png";